// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function AcademyIcons$ProgressImageIcon(props) {
  var progressState = props.progressState;
  var __imageUrl = props.imageUrl;
  var imageUrl = __imageUrl !== undefined ? __imageUrl : "";
  return React.createElement("svg", {
              className: props.className,
              fill: "none",
              viewBox: "0 0 196 196",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("circle", {
                  cx: "98",
                  cy: "98",
                  fill: "white",
                  r: "98"
                }), React.createElement("mask", {
                  id: "mask0",
                  height: "196",
                  width: "98",
                  maskUnits: "userSpaceOnUse",
                  x: "98",
                  y: "0"
                }, React.createElement("rect", {
                      height: "196",
                      width: "98",
                      fill: "white",
                      x: "98"
                    })), progressState === "Started" ? React.createElement("g", {
                    mask: "url(#mask0)"
                  }, React.createElement("circle", {
                        cx: "98",
                        cy: "98",
                        fill: "#5BFF40",
                        r: "98"
                      })) : (
                progressState === "Finished" ? React.createElement("circle", {
                        cx: "98",
                        cy: "98",
                        fill: "#5BFF40",
                        r: "98"
                      }) : null
              ), React.createElement("mask", {
                  id: "mask1",
                  height: "176",
                  width: "176",
                  maskUnits: "userSpaceOnUse",
                  x: "10",
                  y: "10"
                }, React.createElement("circle", {
                      cx: "98",
                      cy: "98",
                      fill: "white",
                      r: "88"
                    })), React.createElement("g", {
                  mask: "url(#mask1)"
                }, React.createElement("image", {
                      id: "image0",
                      height: "196",
                      href: imageUrl,
                      width: "196"
                    })), React.createElement("defs", undefined, React.createElement("pattern", {
                      id: "pattern0",
                      height: "1",
                      width: "1",
                      patternContentUnits: "objectBoundingBox"
                    }, React.createElement("use", {
                          href: "#image0"
                        }))));
}

var ProgressImageIcon = {
  make: AcademyIcons$ProgressImageIcon
};

function AcademyIcons$PlayButton(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 69 72",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M47.8,33.73a2.36,2.36,0,0,1,1.2,1.4,2.77,2.77,0,0,1,0,1.8,2.36,2.36,0,0,1-1.2,1.4l-20.4,12a2.52,2.52,0,0,1-1.9.3,3.15,3.15,0,0,1-1.7-.9,4,4,0,0,1-1.1-2V24.33a3.33,3.33,0,0,1,1.1-2.1,2.59,2.59,0,0,1,1.7-.9,2.32,2.32,0,0,1,1.8.4Z",
                  fill: "currentColor"
                }));
}

var PlayButton = {
  make: AcademyIcons$PlayButton
};

export {
  ProgressImageIcon ,
  PlayButton ,
}
/* react Not a pure module */
